module.exports = __webpack_public_path__ + "img/zx4.e4c851f9.png";